module.exports = __webpack_public_path__ + "static/2007-layer-1-56784a8a490101631407c61cf2a35745.png";